// 实现防抖截流，不再引入loadsh stat 531kb, Gzip: 25.2kb
// 防抖， 如果需要this，请这么调用 debounce.call(this，fn, 150)
export const debounce = (fn, wait = 0) => {
  let timeout = null
  return (...args) => {
    if (timeout) {
      clearTimeout(timeout)
      timeout = null
    }
    timeout = setTimeout(async () => {
      // vue3 淡化this的使用，this可能为undefined， 箭头函数的this，指向上一次作用于的this
      await fn.apply(this, args)
    }, wait)
  }
}
